module.exports = __webpack_public_path__ + "static/media/file-doc.a429fb1a.svg";